import {Box} from '@chakra-ui/react'
import Header from './Header'
import Content from './Content'
import {useEffect, useState} from 'react'
import vocabularyRequest from '@apis/vocabulary'
import {useLocation, useNavigate} from 'react-router-dom'
import {isParamsValid} from '@utils'
import {PATH} from '@utils/Const'

const VocabularyOverview = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const {setId} = location.state || {}
  const [vocabulariesOverview, setVocabulariesOverview] = useState<any>()

  useEffect(() => {
    if (!isParamsValid([setId])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!setId) return
    getVocabularies()
  }, [])

  const getVocabularies = async () => {
    try {
      const res = await vocabularyRequest
        .getVocabularyOverview(setId)
        .then(res => {
          setVocabulariesOverview(res?.data?.data)
        })
    } catch (error) {}
  }

  return (
    <Box>
      <Header vocabulariesOverview={vocabulariesOverview} />
      <Content vocabulariesOverview={vocabulariesOverview} />
    </Box>
  )
}

export default VocabularyOverview
